const TYPE_MAP = {
  image: '远程影像诊断',
  pathology: '远程病理诊断',
  'b-ultrasonography': '远程B超诊断'
};
export const diagnoseMixin = {
  data() {
    return {
      pages: ['远程诊断']
    }
  },
  created() {
    this.setPages();
  },
  watch: {
    $route() {
      this.setPages();
    }
  },
  methods: {
    setPages() {
      const {params, fullPath} = this.$route;
      Log('params', params);
      this.pages.splice(1);
      const prefixMap = {
        '/apply': '申请',
        '/report': '报告书写',
        '/detail': '详情'
      };
      let prefix = '';
      for (let key in prefixMap) {
        if (fullPath.indexOf(key) >= 0) {
          prefix = prefixMap[key];
          break;
        }
      }
      this.pages.push(TYPE_MAP[params.type] + prefix);
    }
  }
}
